import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_PRIORITIES } from "../../../utils/constants";
import { PriorityInterface } from "../../../models/TicketModule/Priority";
import priorityService from "../../../services/ticketService/priorityService";

const usePriorityById = (id: string) =>
  useQuery<PriorityInterface, Error>({
    queryKey: [`${CACHE_KEY_PRIORITIES}ById`, id],
    queryFn: ({ queryKey }) => {
      const [, priorityId] = queryKey;
      return priorityService.GetById(priorityId as string);
    },
    enabled: !!id,
  });

export default usePriorityById;
